module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.tableContent.id
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.tableContent.title)
    }
  }), _vm._v(" "), _c('table', [_c('tbody', {
    domProps: {
      "innerHTML": _vm._s(_vm.tableContent.table)
    }
  }), _vm._v(" "), _c('tfoot', {
    domProps: {
      "innerHTML": _vm._s(_vm.tableContent.footer)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45c429dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/article-items/ContentTableComponent.vue
// module id = 1425
// module chunks = 1